import React from "react";
import { Select, Form, Badge } from "antd";
import "./AdnDropdown.css";

const AdnDropdown = ({
  placeholder,
  options,
  handleChange,
  handleClear,
  name,
  label,
  rules,
  allowClear = false,
  defaultValue,
  className,
  value,
  isBadgeVisible = false,
  disabled,
  valueIsId = true,
  mode,
  dropdownMatchSelectWidth = true,
  showSearch
}) => {
  //const { Option } = Select;
  return (
    <Form.Item
      name={name}
      valuePropName={value}
      label={label}
      rules={rules}
      className="adn-dropdown-size"
    >
      <Select
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        onClear={handleClear}
        defaultValue={defaultValue}
        disabled={disabled}
        allowClear={allowClear}
        className={className}
        mode={mode}
        dropdownMatchSelectWidth={dropdownMatchSelectWidth}
        filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        showSearch={{
            filterOption: (input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
        }}
        options={(options || []).map((d) => ({
            value: d.id,
            label: d.name,
        }))}
      >
        {/*{options?.map((op) => (*/}
        {/*  <Option key={op.id} value={valueIsId ? op.id : op.name}>*/}
        {/*    {isBadgeVisible ? (*/}
        {/*      <Badge color={op.color} text={op.name} />*/}
        {/*    ) : (*/}
        {/*      op.name*/}
        {/*    )}*/}
        {/*  </Option>*/}
        {/*))}*/}
      </Select>
    </Form.Item>
  );
};

export default AdnDropdown;
